<template>
    <support-popup></support-popup>
    <footer>
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-sm-6">
                    <nav class="footer-nav">
                        <ul>
                            <li><a :href="$store.state.hrefPrefix + '/'">{{ $t('home') }}</a></li>
                            <li v-for="category in categories"><a
                                :href="$store.state.hrefPrefix + '/category/' + category.slug">
                                {{ category.category_languages[0].pivot.name }}</a></li>
                            <li><a :href="$store.state.hrefPrefix + '/privacy'">{{ $t('Privacy') }}</a></li>
                            <li v-if="$store.state.language.code === 'tr'"><a :href="$store.state.hrefPrefix + '/masthead'">Künye</a></li>
                            <!--                            <li><a href="#">Contact us</a></li>-->
                        </ul>
                    </nav>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="footer-Newsletter-input" v-if="$store.state.language.code !== 'tr'">
                        <span>{{ $t('subscribe_to_our_newsletter') }}</span>
                        <form :action="$store.state.hrefPrefix + '/subscribe'" method="post" ref="subscribe"
                              @submit.prevent="">
                            <input type="hidden" name="_token" :value="csrf">
                            <div class="Newsletter-input">
                                <input type="text" :placeholder="$t('your_email_address')" name="email"/>
                                <button class="g-recaptcha"
                                        data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                        data-callback="submitSubscribe">
                                    {{ $t('cap_subscribe') }}
                                </button>
                            </div>
                        </form>

                    </div>
                    <button v-if="$store.state.language.code !== 'tr'" class="footer-Support">{{
                            $t('support_us')
                        }}<i><img src="/assets/images/heart-icon.svg"
                                  alt=""></i>
                    </button>
                </div>
                <div class="col-md-4 col-sm-6">
                    <div class="footer-right">
                        <div class="footer-logo">
                            <a v-if="$store.state.language.code === 'ar'" :href="$store.state.hrefPrefix + '/'"><img
                                src="/assets/images/thecradle-ar-logo.svg" alt=""/></a>
                            <a v-else-if="$store.state.language.code === 'en'"
                               :href="$store.state.hrefPrefix + '/'"><img
                                src="/assets/images/the-cradle-logo.svg" alt=""/></a>
                            <a v-else-if="$store.state.language.code === 'tr'"
                               :href="$store.state.hrefPrefix + '/'"><img
                                src="/assets/images/thecradle-tr-logo.svg" alt=""/></a>
                        </div>
                        <ul class="footer-social-links">
                            <li v-if="$store.state.language.code === 'ar'"><a
                                href="https://www.facebook.com/thecradlearabi/" target="_blank">
                                <img src="/assets/images/footer-fb.svg"
                                     onmouseover="this.src='/assets/images/fb-hover.svg'"
                                     onmouseout="this.src='/assets/images/footer-fb.svg'" alt=""/></a></li>
                            <li v-else-if="$store.state.language.code === 'tr'"><a
                                href="https://www.facebook.com/profile.php?id=61573869121346" target="_blank">
                                <img src="/assets/images/footer-fb.svg"
                                     onmouseover="this.src='/assets/images/fb-hover.svg'"
                                     onmouseout="this.src='/assets/images/footer-fb.svg'" alt=""/></a></li>
                            <li v-else><a href="https://www.facebook.com/thecradlemedia/" target="_blank">
                                <img src="/assets/images/footer-fb.svg"
                                     onmouseover="this.src='/assets/images/fb-hover.svg'"
                                     onmouseout="this.src='/assets/images/footer-fb.svg'" alt=""/></a></li>

                            <li v-if="$store.state.language.code === 'ar'"><a
                                href="https://www.instagram.com/thecradlearabi/" target="_blank">
                                <img src="/assets/images/footer-insta.svg"
                                     onmouseover="this.src='/assets/images/insta-hover.svg'"
                                     onmouseout="this.src='/assets/images/footer-insta.svg'" alt=""/> </a></li>
                            <li v-else-if="$store.state.language.code === 'tr'"><a
                                href="https://www.instagram.com/cradleturkiye" target="_blank">
                                <img src="/assets/images/footer-insta.svg"
                                     onmouseover="this.src='/assets/images/insta-hover.svg'"
                                     onmouseout="this.src='/assets/images/footer-insta.svg'" alt=""/> </a></li>
                            <li v-else><a href="https://instagram.com/thecradlemedia?igshid=YmMyMTA2M2Y="
                                          target="_blank">
                                <img src="/assets/images/footer-insta.svg"
                                     onmouseover="this.src='/assets/images/insta-hover.svg'"
                                     onmouseout="this.src='/assets/images/footer-insta.svg'" alt=""/> </a></li>

                            <li v-if="$store.state.language.code === 'ar'"><a href="https://twitter.com/TheCradleArabi"
                                                                              target="_blank">
                                <img src="/assets/images/footer-twitter.svg"
                                     onmouseover="this.src='/assets/images/twitter-hover.svg'"
                                     onmouseout="this.src='/assets/images/footer-twitter.svg'" alt=""/> </a></li>

                            <li v-else-if="$store.state.language.code === 'tr'"><a href="https://x.com/cradleturkiye"
                                                                                   target="_blank">
                                <img src="/assets/images/footer-twitter.svg"
                                     onmouseover="this.src='/assets/images/twitter-hover.svg'"
                                     onmouseout="this.src='/assets/images/footer-twitter.svg'" alt=""/> </a></li>
                            <li v-else><a href="https://twitter.com/thecradlemedia" target="_blank">
                                <img src="/assets/images/footer-twitter.svg"
                                     onmouseover="this.src='/assets/images/twitter-hover.svg'"
                                     onmouseout="this.src='/assets/images/footer-twitter.svg'" alt=""/> </a></li>
                            <li v-if="$store.state.language.code === 'ar'">
                                <a href=" https://t.me/thecradlearabi" target="_blank">
                                    <img src="/assets/images/links-footer.svg"
                                         onmouseover="this.src='/assets/images/links-hover.svg'"
                                         onmouseout="this.src='/assets/images/links-footer.svg'" alt=""/>
                                </a>
                            </li>
                            <li v-else-if="$store.state.language.code === 'tr'">
                                <a href="https://t.me/cradleturkiye" target="_blank">
                                    <img src="/assets/images/links-footer.svg"
                                         onmouseover="this.src='/assets/images/links-hover.svg'"
                                         onmouseout="this.src='/assets/images/links-footer.svg'" alt=""/>
                                </a>
                            </li>
                            <li v-else>
                                <a href="https://t.me/thecradlemedia" target="_blank">
                                    <img src="/assets/images/links-footer.svg"
                                         onmouseover="this.src='/assets/images/links-hover.svg'"
                                         onmouseout="this.src='/assets/images/links-footer.svg'" alt=""/>
                                </a>
                            </li>
                        </ul>
                        <span class="footer-email"><a href="mailto:contact@thecradle.co">contact@thecradle.co</a></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="sub_footer" style="background-color: #54585E">
            <span>{{ $t('copyright') }}</span>
            <ul>
                <li><a :href="$store.state.hrefPrefix + '/terms'">{{ $t('Terms') }}</a></li>
                <li><a :href="$store.state.hrefPrefix + '/privacy'">{{ $t('Privacy') }}</a></li>
                <li v-if="$store.state.language.code === 'en'"><a href="/articles/hello-to-the-cradle">{{
                        $t('About')
                    }}</a></li>
                <li v-if="$store.state.language.code === 'ar'"><a
                    :href="$store.state.hrefPrefix + '/about'">{{ $t('About') }}</a></li>
            </ul>
        </div>
    </footer>
</template>

<script>
import SupportPopup from "@/parts/home/TopBar/SupportPopup.vue";

export default {
    name: "FootBar",
    components: {SupportPopup},
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    },
    props: {
        activeTab: {
            type: String,
            default: 'Home'
        },
        categories: {
            type: Array,
            default: []
        },
    },
    methods: {
        // openSupportPopup(){
        //     document.getElementById('support-popup').style.visibility = 'visible';
        // },
        submitSubscribe(response) {
            console.log(response)
            const form = this.$refs.subscribe;
            form.submit();
        }
    },
    mounted() {
        window.submitSubscribe = this.submitSubscribe;
    }
}
</script>

<style>
@media (max-width: 960px) {
    footer .footer-Newsletter-input .Newsletter-input button {
        margin: 0 auto;
        width: 100%;
    }
}

</style>
